import { createEvent, createStore } from 'effector'

export const actions = {
  setBusinessesFilters: createEvent<BusinessesFilters>('setFilters'),
  setOrphansVisible: createEvent<boolean>('setOrphansVisible'),
  reset: createEvent('reset'),
}

const initialState: FilterState = {
  businessesFilters: undefined,
  orphanVisible: false,
}

export const store = createStore<FilterState>(initialState)
  .on(actions.setBusinessesFilters, (s, businessesFilters) => ({ ...s, businessesFilters }))
  .on(actions.setOrphansVisible, (s, orphanVisible) => ({ ...s, orphanVisible }))
  .on(actions.reset, () => ({ ...initialState }))
